import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {createSelector} from "reselect";

import {geoUtils} from '../utils/geo-utils';

/**
 * Component for drawing shapes to handle mouse interactions on the State map.
 *
 * Allows transparent shapes to be drawn above the visible map to handle hover
 * and click interactions and styling based on hover and selection.
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property selectedIds - array of state fips ids to style as selected
 * @property onClick - callback when a state is clicked (stateFips,cent)
 * @property onAltClick - callback when a state is alt clicked (stateFips,cent)
 * @property onHoverOver - callback when a state is moused over (stateFips,cent)
 * @property onHoverOut - callback when a state is moused out (stateFips)
 *
 * @example
 * return (
 *   <UsaStateHovers
 *     width={500}
 *     height={500}
 *     selectedIds={[...]}
 *     onClick={(stateFips, cent) => {}}
 *     onAltClick={(stateFips, cent) => {}}
 *     onHoverOver={(stateFips, cent) => {}}
 *     onHoverOut={(stateFips) => {}}
 *   />
 * )
 */
export default class UsaStateHovers extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    selectedIds: PropTypes.array,
    onHoverOver: PropTypes.func,
    onHoverOut: PropTypes.func,
    onClick: PropTypes.func,
    onAltClick: PropTypes.func
  }

  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getPaths = createSelector(
    [ this.getWidth, this.getHeight ],
    (width, height) => geoUtils.getAlbersUsaStatePaths(width, height)
  )

  render() {
    const paths = this.getPaths(this.props);

    const getHandlers = state => {
      const onClick = this.props.onClick;
      const onAltClick = this.props.onAltClick;
      const onHoverOver = this.props.onHoverOver;
      const onHoverOut = this.props.onHoverOut;
      const handlers = {};

      if (onClick) {
        handlers.onClick = (event) => {
          if (onAltClick && (event.metaKey || event.ctrlKey)) {
            onAltClick(state.id, state.cent);
          } else {
            onClick(state.id, state.cent);
          }
        }
      }

      if (onHoverOver) {
        handlers.onMouseEnter = () => onHoverOver(state.id, state.cent);

        if (onHoverOut) {
          handlers.onMouseOut = () => onHoverOut(state.id);
        }
        else {
          handlers.onMouseOut = () => onHoverOver(null);
        }
      }

      return handlers;
    };

    const getClassName = (id) => {
      return _.includes(this.props.selectedIds, id) ? "selected" : ""
    }

    return (
      <g className="UsaStateHovers">
        {paths.map(d => (
          <path
            key={d.id}
            d={d.path}
            fillOpacity={0}
            className={getClassName(d.id)}
            {...getHandlers(d)}
          />
        ))}
      </g>
    )
  }
}
